import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link, useNavigate } from "react-router-dom";
import { changeprofilepassword } from "../network/Network";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

const ChangePassword = () => {
	const navigate = useNavigate();
	const token = useSelector((state) => state?.Auth?.token);
	const myrole = useSelector((state) => state?.Auth?.role);
	const [selected, setSelected] = useState("");
	const [formErrors, setFormErrors] = useState([]);
	const [oldpassword1, setOldpassword1] = useState(false);
	const [newpassword1, setNewpassword1] = useState(false);
	const [cpassword1, setCpassword1] = useState(false);
	const [userData, setUserData] = useState({
		current_password: "",
		new_password: "",
		confirm_password: "",
	});
	const [loading, setLoading] = useState(false);

	//   Input Handler
	function handleChange(e) {
		const value = e.target.value;
		setUserData({ ...userData, [e.target.name]: value });
	}
	// ================

	// New Password Funcitonality
	// const Newpassowrd = (e) => {
	// 	e.preventDefault();
	// 	setLoading(true);
	// 	let isValid = true;
	// 	const errors = {};

	// 	// Validate Password
	// 	if (!userData || !userData.current_password) {
	// 		if (!errors || !errors.current_password) {
	// 			if (!errors) errors = {};
	// 			errors.current_password = [];
	// 		}
	// 		errors.current_password.push("Password is required");
	// 		isValid = false;
	// 	} else if (userData.current_password.length < 8) {
	// 		if (!errors || !errors.current_password) {
	// 			if (!errors) errors = {};
	// 			errors.current_password = [];
	// 		}
	// 		errors.current_password.push(
	// 			"Password must be at least 8 characters long",
	// 		);
	// 		isValid = false;
	// 	}

	// 	// Validate Password
	// 	if (!userData || !userData.new_password) {
	// 		if (!errors || !errors.new_password) {
	// 			if (!errors) errors = {};
	// 			errors.new_password = [];
	// 		}
	// 		errors.new_password.push("Password is required");
	// 		isValid = false;
	// 	} else if (userData.new_password.length < 8) {
	// 		if (!errors || !errors.new_password) {
	// 			if (!errors) errors = {};
	// 			errors.new_password = [];
	// 		}
	// 		errors.new_password.push("Password must be at least 8 characters long");
	// 		isValid = false;
	// 	}

	// 	// Validate Confirm Password
	// 	if (!userData || !userData.confirm_password) {
	// 		if (!errors || !errors.confirm_password) {
	// 			if (!errors) errors = {};
	// 			errors.confirm_password = [];
	// 		}
	// 		errors.confirm_password.push("Confirm Password is required");
	// 		isValid = false;
	// 	} else if (userData.new_password !== userData.confirm_password) {
	// 		if (!errors || !errors.confirm_password) {
	// 			if (!errors) errors = {};
	// 			errors.confirm_password = [];
	// 		}
	// 		errors.confirm_password.push("Passwords do not match");
	// 		isValid = false;
	// 	}

	// 	setFormErrors(errors);

	// 	let data = {
	// 		current_password: userData?.current_password,
	// 		password: userData?.new_password,
	// 		confirm_password: userData?.confirm_password,
	// 	};

	// 	changeprofilepassword(data, token, myrole)
	// 		.then((res) => {
	// 			setFormErrors([]);

	// 			Swal.fire({
	// 				position: "center",
	// 				icon: "success",
	// 				text: "Password Has Been Changed",
	// 				showConfirmButton: false,
	// 				timer: 1500,
	// 			});
	// 			setLoading(false);
	// 		})
	// 		.catch((err) => {
	// 			setFormErrors([]);
	// 			const errorData = err?.response?.data?.errors;

	// 			if (errorData) {
	// 				Object.values(errorData)
	// 					.flat()
	// 					.forEach((message) => {
	// 						Swal.fire({
	// 							position: "center",
	// 							icon: "error",
	// 							text: message,
	// 							showConfirmButton: false,
	// 							timer: 2200,
	// 						});
	// 					});
	// 			}
	// 			setLoading(false);
	// 		});
	// };
	const Newpassowrd = (e) => {
		e.preventDefault();
		setLoading(true);
		let isValid = true;
		const errors = {};

		// === Validate Current Password ===
		if (!userData?.current_password) {
			errors.current_password = ["Current password is required"];
			isValid = false;
		} else if (userData.current_password.length < 8) {
			errors.current_password = ["Password must be at least 8 characters long"];
			isValid = false;
		}

		// === Validate New Password ===
		if (!userData?.new_password) {
			errors.new_password = ["New password is required"];
			isValid = false;
		} else if (userData.new_password.length < 8) {
			errors.new_password = ["Password must be at least 8 characters long"];
			isValid = false;
		}

		// === Validate Confirm Password ===
		if (!userData?.confirm_password) {
			errors.confirm_password = ["Confirm password is required"];
			isValid = false;
		} else if (userData.new_password !== userData.confirm_password) {
			errors.confirm_password = ["Passwords do not match"];
			isValid = false;
		}

		setFormErrors(errors);

		if (!isValid) {
			setLoading(false);
			return;
		}

		const data = {
			current_password: userData.current_password,
			password: userData.new_password,
			confirm_password: userData.confirm_password,
		};

		changeprofilepassword(data, token, myrole)
			.then((res) => {
				setFormErrors([]);
				Swal.fire({
					position: "center",
					icon: "success",
					text: "Password Has Been Changed",
					showConfirmButton: false,
					timer: 1500,
				});
				setLoading(false);
				navigate("/personal-info");
			})
			.catch((err) => {
				setFormErrors([]);
				const errorData = err?.response?.data?.errors;

				if (errorData) {
					Object.values(errorData)
						.flat()
						.forEach((message) => {
							Swal.fire({
								position: "center",
								icon: "error",
								text: message,
								showConfirmButton: false,
								timer: 2200,
							});
						});
				}
				setLoading(false);
			});
	};

	// ==================

	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div className="edit-btn back">
										<div className="nav-anchor">
											<i className="fa-solid fa-arrow-left"></i>
										</div>
									</div>
									<h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
										Change Password
									</h5>
								</div>
								<form>
									<div className="row">
										<div className="form-group col-lg-12">
											<input
												type={oldpassword1 ? "text" : "password"}
												className="form-control"
												id="firstName"
												placeholder=" Old Password"
												name="current_password"
												onChange={handleChange}
												value={userData?.current_password}
											/>

											<div className="eye_icon">
												<button
													className="input-inline-btn shop-password new-werapper"
													type="button"
													onClick={() => setOldpassword1(!oldpassword1)}
												>
													<i
														className={
															oldpassword1 ? "fa fa-eye-slash" : "fa fa-eye"
														}
													></i>
												</button>
											</div>
										</div>
										<p className="forms-error">
											{formErrors?.current_password}
										</p>
										<div className="form-group col-lg-12">
											<input
												type={newpassword1 ? "text" : "password"}
												className="form-control"
												id="lastName"
												placeholder=" New Password"
												name="new_password"
												onChange={handleChange}
												value={userData?.new_password}
												// const [newpassword1, setNewpassword1] = useState(false);
											/>
											<button
												className="input-inline-btn shop-password new-werapper"
												type="button"
												onClick={() => setNewpassword1(!newpassword1)}
											>
												<i
													className={
														newpassword1 ? "fa fa-eye-slash" : "fa fa-eye"
													}
												></i>
											</button>
										</div>
										<p className="forms-error">{formErrors?.new_password}</p>

										<div className="form-group col-lg-12">
											<input
												type={cpassword1 ? "text" : "password"}
												className="form-control"
												id="lastName"
												placeholder="Confirm Password"
												name="confirm_password"
												onChange={handleChange}
												value={userData?.confirm_password}
											/>
											<button
												className="input-inline-btn shop-password new-werapper"
												type="button"
												onClick={() => setCpassword1(!cpassword1)}
											>
												<i
													className={
														cpassword1 ? "fa fa-eye-slash" : "fa fa-eye"
													}
												></i>
											</button>
										</div>
										<p className="forms-error">
											{formErrors?.confirm_password}
										</p>
									</div>
									<Link
										className="btn wrapper-btn-main mb-5 log-in mt-3 level-7 primary-regular-font text-decoration-none"
										to=""
									>
										<span
											onClick={(e) => Newpassowrd(e)}
											className="loading-btn loading bg-wrapper "
										>
											{loading ? (
												<i className="fa fa-spinner"></i>
											) : (
												"Save Changes"
											)}
										</span>
									</Link>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default ChangePassword;
